import { jsonldEmail } from './JsonldStore';

export const updateJsonldEmail = (value) => jsonldEmail.update((oldValue) => value);
